jQuery(document).ready(function($) {
             
    $('.cookie-tema .accept').on('click', function() {
        localStorage.setItem("cookie-lgpd", 'aceito');
        $(".cookie-tema").fadeOut(); 
    });
    var status_cookie = localStorage.getItem('cookie-lgpd');
    if (status_cookie == null) {
        $(".cookie-tema").css("display", "block");
    } else {
        $(".cookie-tema").hide();
    }
});